;
/*!
 *subitotexto.effects.gifarrival.js
 */
SubitoTexto.effects.gifArrival = {
	init: function () {

		var $ = jqPla,
			_this = SubitoTexto.effects.gifArrival;

		_this.gifSrc = '/_/images/mona-whistle.gif';
		_this.direction = 'up';
		_this.duration = 2200;
	},

	launch: function () {
		var $ = jqPla,
			_this = SubitoTexto.effects.gifArrival;

		SubitoTexto.effects.currentlyPlaying = true;


		var loadedImg = new Image;


		loadedImg.onload = _this.placeImage( loadedImg );

		loadedImg.src = _this.gifSrc;
	},


	placeImage: function ( loadedImg ) {
		var $ = jqPla,
			_this = SubitoTexto.effects.gifArrival;

		var imgHeight = loadedImg.height,
			imgWidth = loadedImg.width;


		if ( _this.direction == 'up' ) {
			_this.$gif = $( '<img class="effect bottomgif" src="' + Math.random() + '" />' ).appendTo( $( 'body' ) );


			// This is where the "restarting the gif without reloading with a random query string" magic begins
			_this.$gif.attr( 'data-uri', 'http://' + Math.floor( Math.random() * 100000 ) + 1 );

			setTimeout( function () {
				_this.$gif[ 0 ].src = _this.gifSrc;
			}, 2 );
			// END magic



			setTimeout( function () {
				_this.$gif.remove();

				SubitoTexto.nepastoucheranimation.handleComplete( 1, 0, 0 );
				SubitoTexto.effects.currentlyPlaying = false;

			}, _this.duration );
		}
	}
};